/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Bolt(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Bolt',
      'aria-hidden': true,
      focusable: false,
      width:  11 * scale,
      height: 15 * scale,
      viewBox: '0 0 11 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M4.66 6.017h5.16a.5.5 0 0 1 .44.738l-5.387 7.947c-.134.248-.513.118-.466-.16L5.66 9.017H.5a.5.5 0 0 1-.44-.738L5.45.33c.133-.248.51-.118.465.16z","fill":"currentColor","fillRule":"evenodd"}))
}
